<template>
    <span>
        <input type="checkbox" ref="input">
    </span>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true,
                validator: function (value) {
                    return (value === 0 || value === 1)
                }
            },
            enabled: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                'instance': null,
                'input': this.input
            }
        },

        watch: {
            value(val) {
                this.setValue(val);
            },
            enabled(val) {
                if (val) {
                    return this.instance.enable();
                }

                this.instance.disable();
            }
        },
        methods: {
            setValue(value) {
                let newValue = Boolean(this.value);

                if (this.instance.isChecked() !== newValue) {
                    if (!newValue) {
                        this.instance.element.checked = newValue;
                    }
                    this.instance.setPosition(newValue);
                }
            }
        },
        mounted() {
            this.instance = new Switchery(this.$refs.input, { size: 'small', color: '#5466b0' });

            let vm = this;
            this.$refs.input.onchange = function () {
                vm.$emit('input', Number(vm.$refs.input.checked));
            };

            this.setValue(this.value);
        }
    }
</script>
